import React from "react";
import CustomButton from "../CustomButton";
import ModalWrapper from "../Modal/ModalWrapper";
import Text from "../../styleguide/Text";

export interface ConfirmationModalProps {
  show: boolean;
  handleClose?: () => void;
  title?: string;
  subtitle?: string;
  leftButtonText?: string;
  leftButtonOnClick?: () => void;
  rightButtonText?: string;
  rightButtonOnClick?: () => void;
  leftButtonColor?:
    | "error"
    | "info"
    | "inherit"
    | "primary"
    | "secondary"
    | "success";
  rightButtonColor?:
    | "error"
    | "info"
    | "inherit"
    | "primary"
    | "secondary"
    | "success";
  leftButtonVariant?: "contained" | "outlined" | "text";
  rightButtonVariant?: "contained" | "outlined" | "text";
  modalSize?: "sm" | "lg" | "xl";
}

function ConfirmationModal({
  show,
  handleClose,
  title,
  subtitle,
  leftButtonText,
  leftButtonOnClick,
  rightButtonText,
  rightButtonOnClick,
  leftButtonColor,
  rightButtonColor,
  leftButtonVariant = "contained",
  rightButtonVariant = "contained",
  modalSize = "sm",
}: ConfirmationModalProps) {
  const leftButtonClick = () => {
    handleClose && handleClose();
    leftButtonOnClick && leftButtonOnClick();
  };
  const rightButtonClick = () => {
    handleClose && handleClose();
    rightButtonOnClick && rightButtonOnClick();
  };
  return (
    <ModalWrapper
      modalSize={modalSize}
      title={title}
      show={show}
      handleClose={handleClose}>
      {subtitle && (
        <Text className="mb-8" variant="body1">
          {subtitle}
        </Text>
      )}
      <div className="d-flex justify-content-between w-100">
        <CustomButton
          variant={leftButtonVariant}
          color={leftButtonColor}
          onClick={leftButtonClick}>
          {leftButtonText ?? "Nu"}
        </CustomButton>
        <CustomButton
          variant={rightButtonVariant}
          color={rightButtonColor}
          onClick={rightButtonClick}>
          {rightButtonText ?? "Da"}
        </CustomButton>
      </div>
    </ModalWrapper>
  );
}

export default ConfirmationModal;
